'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Wrapper from '../components/StyledComponents/Wrapper';
import LoadingContainer from '../components/StyledComponents/LoadingContainer';
import { OLAF, LORAX } from 'HubStyleTokens/colors';
var HELP_TEXT_TIMEOUT = 1000 * 5;
var PAUSE_TIMEOUT = 1000;

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function withPauseAndHelpLogic(WrappedComponent) {
  var WithPauseAndHelpLogic = /*#__PURE__*/function (_React$Component) {
    _inherits(WithPauseAndHelpLogic, _React$Component);

    function WithPauseAndHelpLogic(props) {
      var _this;

      _classCallCheck(this, WithPauseAndHelpLogic);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(WithPauseAndHelpLogic).call(this, props));
      _this.state = {
        isReady: false,
        displayHelpText: false
      };
      _this.startHelpTextTimeout = _this.startHelpTextTimeout.bind(_assertThisInitialized(_this));
      _this.cancelHelpTextTimeout = _this.cancelHelpTextTimeout.bind(_assertThisInitialized(_this));
      _this.handlePause = _this.handlePause.bind(_assertThisInitialized(_this));
      _this.actuallyHandlePause = _this.actuallyHandlePause.bind(_assertThisInitialized(_this));
      _this.handlePlay = _this.handlePlay.bind(_assertThisInitialized(_this));
      _this.handleReady = _this.handleReady.bind(_assertThisInitialized(_this));
      _this.handleChangeVideo = _this.handleChangeVideo.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(WithPauseAndHelpLogic, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startHelpTextTimeout();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cancelTrackPauseTimeout();
        this.cancelHelpTextTimeout();
      }
    }, {
      key: "startHelpTextTimeout",
      value: function startHelpTextTimeout() {
        var _this2 = this;

        this.setState({
          displayHelpText: false
        });
        this.cancelHelpTextTimeout();
        this.displayHelpTextTimeoutId = window.setTimeout(function () {
          _this2.setState({
            displayHelpText: true
          });
        }, HELP_TEXT_TIMEOUT);
      }
    }, {
      key: "cancelHelpTextTimeout",
      value: function cancelHelpTextTimeout() {
        clearTimeout(this.displayHelpTextTimeoutId);
      }
    }, {
      key: "cancelTrackPauseTimeout",
      value: function cancelTrackPauseTimeout() {
        clearTimeout(this.trackPauseTimeout);
        this.trackPauseTimeout = false;
      }
    }, {
      key: "handlePause",
      value: function handlePause() {
        this.cancelTrackPauseTimeout();
        this.trackPauseTimeout = window.setTimeout(this.actuallyHandlePause, PAUSE_TIMEOUT);
      }
    }, {
      key: "actuallyHandlePause",
      value: function actuallyHandlePause() {
        var onPause = this.props.onPause;

        if (onPause) {
          onPause();
        }

        this.cancelTrackPauseTimeout();
      }
    }, {
      key: "handlePlay",
      value: function handlePlay() {
        var onPlay = this.props.onPlay;

        if (!this.trackPauseTimeout) {
          if (onPlay) {
            onPlay();
          }
        } else {
          this.cancelTrackPauseTimeout();
        }
      }
    }, {
      key: "handleReady",
      value: function handleReady() {
        var onReady = this.props.onReady;
        this.setState({
          isReady: true
        });

        if (onReady) {
          onReady();
        }
      }
    }, {
      key: "handleChangeVideo",
      value: function handleChangeVideo() {
        this.setState({
          isReady: false
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            displayHelpText = _this$state.displayHelpText,
            isReady = _this$state.isReady;

        var _this$props = this.props,
            onPlay = _this$props.onPlay,
            onPause = _this$props.onPause,
            onReady = _this$props.onReady,
            loadingBackground = _this$props.loadingBackground,
            placeholderAspectRatio = _this$props.placeholderAspectRatio,
            passThroughProps = _objectWithoutProperties(_this$props, ["onPlay", "onPause", "onReady", "loadingBackground", "placeholderAspectRatio"]);

        return /*#__PURE__*/_jsxs(Wrapper, {
          isReady: isReady,
          placeholderAspectRatio: placeholderAspectRatio,
          loadingBackground: loadingBackground,
          children: [/*#__PURE__*/_jsx(LoadingContainer, {
            displayHelpText: displayHelpText
          }), /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
            startHelpTextTimeout: this.startHelpTextTimeout,
            cancelHelpTextTimeout: this.cancelHelpTextTimeout,
            onPause: this.handlePause,
            onPlay: this.handlePlay,
            onReady: this.handleReady,
            onChangeVideo: this.handleChangeVideo
          }, passThroughProps))]
        });
      }
    }]);

    return WithPauseAndHelpLogic;
  }(React.Component);

  WithPauseAndHelpLogic.defaultProps = {
    videoPlaySpeed: 100,
    loadingBackground: OLAF,
    color: LORAX,
    placeholderAspectRatio: 16 / 9
  };
  WithPauseAndHelpLogic.displayName = "WithPauseAndHelpLogic(" + getDisplayName(WrappedComponent) + ")";
  return WithPauseAndHelpLogic;
}